var exports = {
  "Pc": "MemeFormFields.module__tagsContainer___UXZKRD",
  "Pr": "MemeFormFields.module__tagsHeader___UXZKRD",
  "ft": "MemeFormFields.module__tagsHeaderLabel___UXZKRD",
  "C_": "MemeFormFields.module__tagsInputRow___UXZKRD",
  "Cs": "MemeFormFields.module__tagsList___UXZKRD",
  "r3": "MemeFormFields.module__tagChip___UXZKRD",
  "xH": "MemeFormFields.module__tagRemoveButton___UXZKRD",
};

module.exports = exports;
